import React from "react";
const ComponentDecorator = (href, text, key) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a href={href} key={key} target="_blank">
    {text}
  </a>
);
export default ComponentDecorator;
